<template>
  <!-- Main Content -->
  <v-card class="mx-auto" height="100%" width="100%">
    <!-- Left Navigation -->
    <left-navigation
      ref="left-navigation"
      v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
    ></left-navigation>

    <!-- Top App Bar -->
    <top-navigation ref="top-navigation"></top-navigation>

    <!-- Contents -->
    <v-main>
      <v-container class="fill-height pa-0" fluid>
        <v-row no-gutters class="layout-cols-row">
          <!-- Left rail -->
          <v-col
            md="3"
            class="layout-cols layout-nav"
            v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
          >
            <settings-left-navigation
              ref="settings-left-navigation"
            ></settings-left-navigation>
          </v-col>
          <!-- Center rail -->
          <v-col
            cols="12"
            md="9"
            class="layout-cols"
            v-if="$vuetify.breakpoint.mdAndUp || !navMenuOpen"
          >
            <settings-center-rail
              ref="settings-center-rail"
            ></settings-center-rail>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-card>
</template>

<script>
const TopNavigation = () =>
  import(
    /* webpackChunkName: "components-global-TopNavigation" */ `../components/global/TopNavigation.vue`
  );
const LeftNavigation = () =>
  import(
    /* webpackChunkName: "components-global-LeftNavigation" */ `../components/global/LeftNavigation.vue`
  );
const SettingsLeftNavigation = () =>
  import(
    /* webpackChunkName: "components-settings-SettingsLeftNavigation" */ `../components/settings/SettingsLeftNavigation.vue`
  );
const SettingsCenterRail = () =>
  import(
    /* webpackChunkName: "components-settings-SettingsCenterRail" */ `../components/settings/SettingsCenterRail.vue`
  );

export default {
  components: {
    TopNavigation,
    LeftNavigation,
    SettingsLeftNavigation,
    SettingsCenterRail
  },
  data: function() {
    return {
      settingsNavSelected: "account"
    };
  },
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    navMenuOpen() {
      return this.$root.$children[0].navMenuOpen;
    }
  }
};
</script>

<style scoped lang="stylus"></style>
